<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">意向发布项目</div>

      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="状态">
            <a-select default-value="全部" style="width: 160px">
              <a-select-option value="all">全部</a-select-option>
              <a-select-option value="published">已披露</a-select-option>
              <a-select-option value="draft">草稿</a-select-option>
              <a-select-option value="closed">已关闭</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="项目名称">
            <a-input-search placeholder="请输入项目名称" style="width: 250px" />
          </a-form-item>

          <a-button type="primary" style="margin-top: 4px;">查询</a-button>
          <a-button style="margin-left: 10px;">重置</a-button>
        </a-form>
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        rowKey="id"
        :pagination="{ pageSize: 10, total: data.length }"
        :scroll="{ x: 1400 }"
        locale="{ emptyText: '暂无数据' }"
      >
        <template slot="operation">
          <a style="color: #1890ff;">查看</a>
        </template>
      </a-table>
    </a-card>
  </div>
</template>


<script>
export default {
  data() {
    return {
      columns: [
        { title: '序号', dataIndex: 'index', width: 80, key: 'index' },
        { title: '项目名称', dataIndex: 'name', width: 250, key: 'name' },
        { title: '项目编号', dataIndex: 'code', width: 180, key: 'code' },
        { title: '标的名称', dataIndex: 'targetName', width: 250, key: 'targetName' },
        { title: '计租数量(租赁面积)', dataIndex: 'area', width: 180, key: 'area' },
        { title: '项目状态', dataIndex: 'status', width: 100, key: 'status' },
        { title: '披露开始时间', dataIndex: 'startTime', width: 160, key: 'startTime' },
        { title: '披露截止时间', dataIndex: 'endTime', width: 160, key: 'endTime' },
        { title: '操作', key: 'operation', fixed: 'right', width: 120, scopedSlots: { customRender: 'operation' } },
      ],
      data: [] // 暂无数据
    };
  }
};

</script>

<style scoped>
.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input{
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}
</style>